import { combineReducers, Dispatch, Action, AnyAction } from 'redux'
import { History } from 'history'
import { connectRouter, RouterState } from 'connected-react-router'
import { firebaseReducer } from 'react-redux-firebase'
import { all, fork } from 'redux-saga/effects'
import DeliveryTrackingSaga from './DeliveryTracking/sagas'
import { DeliveryTrackingReducer } from './DeliveryTracking/reducer'
import { DeliveryTrackingState } from './DeliveryTracking/types'
import { DeliveryRatingReducer } from './DeliveryRating/reducer'
import { DeliveryRatingState } from './DeliveryRating/types'
import DeliveryRatingSaga from './DeliveryRating/sagas'

interface containersState {
    DeliveryTracking: DeliveryTrackingState,
    DeliveryRating: DeliveryRatingState
}

const containersReducer = combineReducers({
  DeliveryTracking: DeliveryTrackingReducer,
  DeliveryRating: DeliveryRatingReducer,
})

export interface ApplicationState {
    containers: containersState,
    router: RouterState,
    firebase: any
}

export const rootReducer = (history: History) => combineReducers<ApplicationState>({
  containers: containersReducer,
  router: connectRouter(history),
  firebase: firebaseReducer,
})

export function* rootSaga() {
  yield all([
    fork(DeliveryTrackingSaga),
    fork(DeliveryRatingSaga),
  ])
}

export interface ConnectedReduxProps<A extends Action = AnyAction> {
    dispatch: Dispatch<A>
}
